<template>
  <main :class="this.$isIsef ?
  'home-section home-section_isef-home' : !this.isStemExpo ?
  'home-section section is-paddingless' : 'home-section_stem-expo'" :key="refreshComponentKey">
    <cookies v-if="!$isEngCom"/>
    <!-- Load Explorer Pages   -->
    <banner v-if="this.isExpo"
            ref="banner"
            :landingPage="false"
            @start="startNow"/>
    <!-- Load only Stem Expo   -->
    <stem-banner v-if="this.isStemExpo" :key="$i18n.locale"/>
    <!-- Load only Career & Stem   -->
    <banner v-if="this.isCareerHall || this.isStemHall"
            ref="banner" :landingPage="false" @start="startNow"/>
    <!--  Not part of expo, career & stem -->
    <span v-if="!this.isStemExpo && !this.isCareerHall && !this.isStemHall && !isExplorePage" >
      <banner ref="banner"
              :landingPage="false"
              @start="startNow"
              :isScienceDay="isScienceDay"
              :isStateScienceDay="isStateScienceDay"
              :isBuckeye="isBuckeye"
              :key="$i18n.locale"/>
      <language-dropdown v-if="$isYSC"
                         class="language-white-background"/>
      <scroll-point />
      <explanation-text v-if="$isHeise"></explanation-text>
      <categories ref="categoryCarousel"
                  v-bind="{selectedCategoryID, userCategories}"
                  :showSponsor="showSponsor"
                  @viewCategory="filterSearch" />
      <div v-if="showAd"
           class="ad-container">
        <double-click-ad :key="this.$route.params.category || null"
                         path="/14357335/Make-Top"
                         :category="this.$route.params.category"
                         :language="$i18n.locale" />
      </div>
      <toggle-theme />
      <section v-if="showSortContainer"
               class="sort-container container is-flex sort-container-loggedout"
               :class="{'title-and-sort': $isEngCom || (selectedCategoryID > 0 && selectedCategory.parentID > 0)}">
        <h2 v-if="($isEngCom || (selectedCategoryID > 0 && selectedCategory.parentID > 0)) && !isLoading"
            class="title current-title is-marginless is-size-5-mobile">{{ currentTitle }}</h2>
        <div class="sort select">
          <select v-model="sortBy"
                  @change="updateSort"
                  :placeholder="RECENT_ACTIVITY">
            <option class="option "
                    v-for="option in sortOptions"
                    :key="option.value"
                    :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </section>
    </span>
    <section class="projects-container"
             :class="{container: (hasCategoryFilter && !isMobile),
             'filtered-projects-container' : hasCategoryFilter, 'stories' : $isEngCom}">
      <template v-if="hasRows && (!hasCategoryFilter)">
        <!-- YSC -->
        <div v-for="(row, offset) in yscRows"
             :key="row.title">
          <project-row ref="yscRows"
                       rowType="yscRows"
                       :rowState="rowState[row.title]"
                       :title="row.title"
                       :projects="rowProjects[row.title]"
                       :offset="offset"
                       :categorySlug="row.request.name === 'projectsByCategory' ?
                       row.request.params.slug : null"
                       :showLoading="true"
                       @fetch="populateRow"
                       @fetchSub="populateSubCategoryRow"
                       @viewCategory="filterSearch" />
        </div>

        <!-- YSC Stem Expo -->
        <div v-for="(row, offset) in yscStemExpoRows"
             :key="row.title">
          <project-row ref="yscStemExpoRows"
                       rowType="yscStemExpoRows"
                       :rowState="rowState[row.title]"
                       :title="row.title"
                       :projects="rowProjects[row.title]"
                       :offset="offset"
                       :categorySlug="row.request.name === 'projectsByCategory' ?
                       row.request.params.slug : null" :showLoading="true"
                       @fetch="populateRow"
                       @fetchSub="populateSubCategoryRow"
                       @viewCategory="filterSearch"
                       :size="row.request.params.size" />
        </div>

        <!-- Explore-->
        <div v-for="(row, offset) in exploreRows" :key="row.title">
          <project-row ref="exploreRows" rowType="exploreRows" :rowState="rowState[row.title]" :title="row.title" :exploreTemplateID="row.request.params.templateID" :exploreAlphabets="row.request.params.alphabets" :explorelastNames="row.request.params.lastNames" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true"  @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch" :size="row.request.params.size"></project-row>
        </div>

        <!-- Isef Career Hall -->
        <div v-for="(row, offset) in isefCareerHallRows" :key="row.title">
          <project-row ref="isefCareerHallRows" rowType="isefCareerHallRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true"  @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch" :size="row.request.params.size"></project-row>
        </div>

        <!-- Isef Experiential Hall -->
        <div v-for="(row, offset) in isefSTEMExperientialHallRows" :key="row.title">
          <project-row ref="isefSTEMExperientialHallRows" rowType="isefSTEMExperientialHallRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true"  @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch" :size="row.request.params.size"></project-row>
        </div>

        <!-- Isef Awards -->
        <div v-for="(row, offset) in isefRows" :key="row.title">
          <project-row ref="isefRows" rowType="isefRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true"  @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch" :size="row.request.params.size"></project-row>
        </div>
      <span v-if="!this.isStemExpo && !this.isCareerHall && !this.isStemHall && !this.isExplorePage" >
        <!-- AJAS -->
        <div v-for="(row, offset) in ajasRows" :key="row.title">
          <project-row ref="ajasRows" rowType="ajasRows" :rowState="rowState[row.title]" is-large="row.isLarge" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="isLoading"  @fetch="populateRow" @viewCategory="filterSearch"></project-row>
        </div>
        <!-- Featured -->
          <div v-for="(row, offset) in featuredRows" :key="row.title">
<!--            <div style="background-color: blue !important; height: 50%; width: 100%; position: absolute; margin-left: 1rem;"/>-->
            <project-row ref="featuredRows" v-if="rowHasProjects(row.title)" rowType="featuredRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true" @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch"></project-row>
            <project-row ref="bookmarkedRows" v-else rowType="featuredRows" :title="row.title" :offset="offset" :projects="rowProjects[row.title]" :showLoading="true" @fetch="populateRow"></project-row>
          </div>
          <!-- Wettbewerbe -->
          <div v-if="isHeise">
            <div v-for="(row, offset) in wettbewerbeRows" :key="row.title">
              <project-row ref="wettbewerbeRows" rowType="wettbewerbeRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true" @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch"></project-row>
            </div>
          </div>
        <!-- Awarded Projects -->
        <div v-if="isCnmi || isOasFairs || isSigmaxi">
          <div v-for="(row, offset) in awardedProjects" :key="row.title">
              <project-row ref="awardedProjects" rowType="awardedProjects" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true" @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch"></project-row>
            </div>
        </div>

          <!-- Recent/Contributed -->
          <div v-if="!isOasam && !isOasFairs && !isSigmaxi">
            <div v-for="(row, offset) in pbRows" :key="row.title">
              <project-row ref="pbRows" v-if="rowHasProjects(row.title)" rowType="pbRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="true" @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch"></project-row>
            </div>
          </div>

          <!-- User Interest Categories -->
          <div v-if="isLoggedIn && showPartner && !isOasFairs && !isSigmaxi" class="interests">
            <span class="is-flex-desktop interests-sub">
              <span v-if="!this.$isIsef" class="is-flex adjust-margin-personalize">
                <category-star class="mr-2 mt-2" :context="`homepage-interests`"></category-star>
                <div class="step-3-makehome-obd step-3-makehome-obm" style="position:static">
                    <h2 class="interests-title">{{ $t("explore.myInterests") }}</h2>
                </div>
              </span>
              <div class="personalize-button-container" >
                <personalize-button v-if="$isMake || $isEngCom" type="cta-button" class="personalize-button-margin cta-button regular" @click="personalizeFeed" qa="pers-btn">
                  {{ $t("explore.personalize") }}
                </personalize-button>
              </div>
            </span>
            <div v-if="!this.$isIsef" class="user-tags is-flex mt-4">
              <a v-for="category in userCategoriesSorted" :key="category.name" @click="clickCategory(category)" class="gtm-category-tag">
                <span class="tag is-flex gtm-category-tag">
                  {{category.parentID === 0 ? category.name.toUpperCase() : category.name}}
                </span>
              </a>
            </div>
          </div>
          <div v-if="!isOasFairs && !isSigmaxi">
            <div v-for="(row, offset) in userCategoryRows" :key="row.title">
              <project-row
                  ref="userCategoryRows"
                  rowType="userCategoryRows"
                  :rowState="rowState[row.title]"
                  :title="row.title"
                  :projects="rowProjects[row.title]"
                  :offset="offset"
                  :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null"
                  :showLoading="isLoading"
                  :showIsefHome="true"
                  :showParent="true"
                  @fetch="populateRow"
                  @fetchSub="populateSubCategoryRow"
                  @viewCategory="filterSearch"
              />
            </div>
          </div>
          <!-- Remaining Categories -->
          <div class="interests is-flex all-categories" v-if="isLoggedIn">
            <h2 :class="((isIsefHome || isCareerHall) && $isIsef) ?
            'interests-title interests-title_isef all-categories-title' : 'interests-title all-categories-title'">
              {{ allCategoriesTitle }}
            </h2>
            <personalize-button v-if="this.$isYSC"
                                type="cta-button" class="personalize-button-margin ml-2"
                                :class="{'remove-margin': !userCategories.length}"
                                @click="filterOptions" qa="pers-btn">
                  {{ buttonText }}
            </personalize-button>
          </div>
          <div v-for="(row, offset) in restCategoryRows" :key="row.title">
            <project-row ref="restCategoryRows" rowType="restCategoryRows" :rowState="rowState[row.title]" :title="row.title" :projects="rowProjects[row.title]" :offset="offset" :categorySlug="row.request.name === 'projectsByCategory' ? row.request.params.slug : null" :showLoading="isLoading" @fetch="populateRow" @fetchSub="populateSubCategoryRow" @viewCategory="filterSearch" qa="cat-row"></project-row>
          </div>
          <div v-if="!isLoggedIn && hasRows && showPersonalize" class="personalize-button-container adjust-margin">
            <personalize-button type="cta-button" size="large" class="gtm-footer-personalize-feed" @click="personalizeFeed('personalize-feed')" qa="personalize-btn">{{ $t("sectionHome.button1" )}}</personalize-button>
          </div>
        </span>
      </template>

      <!-- Exploring Category with sub category rows-->
      <div v-if="hasCategoryFilter" class="filtered-container">
        <div v-if="hasError" class="not-found">{{error}}</div>
        <template v-if="showSubCategoryRows">
          <div v-for="(sub, offset) in selectedCategorySubCategories" :key="sub.id">
            <project-row ref="subCategoryRows" :rowState="subCategoryRowState[sub.slug]"  :title="sub.name" :projects="subCategoryProjects[sub.slug]" :offset="offset" :showLoading="true" @fetch="populateSubCategoryRow" @fetchSub="populateSubCategoryRow" :categorySlug="sub.slug" @viewCategory="filterSearch"></project-row>
          </div>
        </template>
        <!-- Show Award Sub-rows -->
<!--        <template v-if="showSubAwardRows">-->
<!--          <div v-for="(sub, offset) in subAwardCategories" :key="sub.name">-->
<!--            <project-row v-if="subAwardHasProjects(sub.slug)" ref="subAwardRows"-->
<!--              :rowType="sub.slug"  :rowState="subCategoryRowState[sub.slug]"  :title="sub.name" :imgSrc="`/static/ysc/awards/${sub.slug}.svg`"-->
<!--              :projects="subAwardProjects[sub.slug]" :offset="offset" :showLoading="true" :categorySlug="sub.slug"-->
<!--              @fetch="populateSubAwardRow">-->
<!--            </project-row>-->
<!--          </div>-->
<!--        </template>-->
      </div>
      <span v-if="!$isYSC && !isOasFairs && !isSigmaxi" :class="(this.isIsefHome && this.$isIsef) ?
        'no-boards-message no-boards-message_isef' : 'no-boards-message'">
        <p v-if="$isStories">{{ $t('findMoreStories-1') }} <a
            :class="{'no-boards-message_isef': this.isIsefHome}"
            @click="exploreAll">{{ $t('findMoreStories-2') }}</a> {{ $t('findMoreStories-3') }}
        </p>
        <p v-else-if="exloreAllMessage" :class="{'no-boards-message_isef': this.$isIsef}">
          {{$t('sectionHome.moreText1')}} <a
            tabindex="0"
            :class="{'no-boards-message_isef': (isIsefHome && this.$isIsef)}"
            @keypress.enter.space="exploreAll"
            @click="exploreAll">{{$t('sectionHome.link')}}
          </a>{{$t('sectionHome.moreText2')}}
        </p>
      </span>
    <choose-template v-if="showChooseTemplateModal" @close="close"></choose-template>
    </section>
    <scroll-to-top :emit="true" @click="_callback('scrollToPoint')"></scroll-to-top>
    <categories-modal ref="categoryModal" @categoriesChanged="userCategoryInterestsChanged" ></categories-modal>
    <country-modal ref="countryModal" ></country-modal>
    <filter-modal v-if="$isYSC" ref="filterModal"></filter-modal>
  </main>
</template>

<script>
import home from '@/api/home'
import socket from '@/libs/socket'
import auth from '@/mixins/auth'
import breakpoints from '@/libs/breakpoints'

import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import Cookies from './Cookies'
import ProjectRow from './ProjectRow.vue'
import ScrollToTop from '@/components/Controls/ScrollTopButton'
import Categories from './categories'
import CategoriesModal from '@/components/Modals/Categories'
import CountryModal from '@/components/Modals/Countries'
import LanguageDropdown from '@/components/Controls/LanguageDropdown'
import ScrollPoint from '@/components/Controls/ScrollPoint'
import DoubleClickAd from '@/components/Modals/DoubleClickAd'
import PersonalizeButton from '@/components/Controls/ButtonTemplate'
import StemBanner from '@/components/Pages/StemExpoLobby/StemBanner'
import ToggleTheme from '@/components/Controls/ToggleTheme'
import ChooseTemplate from '@/components/Modals/ChooseTemplate'
import ExplanationText from './ExplanationText.vue'

import componentState from '@/mixins/component-state'
import scrollLock from '@/mixins/scroll-lock'
import homepageStrings from '@/mixins/homepage'
import yscStrings from '@/mixins/ysc'
import ajasStrings from '@/mixins/ajas'
import { getEnvName } from '@/mixins/util'
import i18n from '@/i18n'
import CategoryStar from '@/components/Controls/CategoryStar'
import FilterModal from '@/components/Modals/Filter'
import setYear from '@/mixins/set-year'

const Banner = () => import('./Banner').then(({ Banner }) => Banner(getEnvName()))

const pbOptions = [
  { value: 'most_views', label: i18n.t('viewAllLabels.mostViews') },
  { value: 'newest', label: i18n.t('viewAllLabels.newest') },
  { value: 'most_likes', label: i18n.t('viewAllLabels.mostLikes') },
  { value: 'recent_activity', label: i18n.t('viewAllLabels.recentActivity') },
  { value: 'most_subscribers', label: i18n.t('viewAllLabels.mostFollows') }
]

const newengOptions = [
  { value: 'most_views', label: 'Most Views' },
  { value: 'newest', label: 'Newest' },
  { value: 'alphabetically', label: 'A-Z' }
]

const placeHolderProjects = [{ id: -1 }, { id: -2 }, { id: -3 }, { id: -4 }, { id: -5 }, { id: -6 }, { id: -7 }, { id: -8 }]
// add more upto 12 if needed

export default {
  components: {
    InfiniteScroll,
    Cookies,
    Categories,
    ScrollToTop,
    ProjectRow,
    ScrollPoint,
    CategoriesModal,
    CountryModal,
    CategoryStar,
    ChooseTemplate,
    StemBanner,
    Banner,
    LanguageDropdown,
    DoubleClickAd,
    PersonalizeButton,
    ToggleTheme,
    ExplanationText,
    FilterModal
  },
  mixins: [auth, componentState, scrollLock, homepageStrings, yscStrings, ajasStrings, setYear],
  metaInfo: function () {
    return {
      title: this.currentTitle
    }
  },
  data: function () {
    return {
      hasRows: false,
      exploreRows: [],
      yscRows: [],
      yscStemExpoRows: [],
      isefCareerHallRows: [],
      isefSTEMExperientialHallRows: [],
      isefRows: [],
      ajasRows: [],
      premiumRows: [],
      featuredRows: [],
      fablabsRows: [],
      bookmarkedRows: [],
      wettbewerbeRows: [],
      awardedProjects: [],
      pbRows: [],
      userCategoryRows: [],
      restCategoryRows: [],
      rowProjects: {},
      projects: [],
      subCategoryProjects: {},
      dispatchMethod: '',
      sortBy: this.defaultSort,
      filterSortBy: null,
      sorting: false,
      offset: 0,
      limit: 12,
      currentCategory: '',
      currentBoard: '',
      error: '',
      notFoundErrorMessage: `There are no community ${this.boardLabel(true)} that match your search.`,
      navForFilter: '',
      fetchCount: 0,
      selectedCategoryID: 0,
      rowState: {},
      subCategoryRowState: {},
      userCategories: [],
      metaTitle: '',
      showChooseTemplateModal: false,
      openDropdown: false,
      subAwardProjects: {},
      userTags: [],
      subAwardCategories: []
    }
  },
  beforeMount: function () {
    this.$store.dispatch('clearCategories')
  },
  mounted: function () {
    this.initCallbacks()
    // Check when banner is rendered
    if (this.$isIsef) {
      const interval = setInterval(() => {
        if (this.$refs.banner) {
          this.getOverlayPosY(this.$refs.banner)
          clearInterval(interval)
        }
      }, 50)
    }
    if (!this.hasCategories) {
      this.$store.dispatch('getCategories', this.$route.path.substring(1)).then(() => {
        this.runWhenMounted()
      })
    } else {
      this.runWhenMounted()
    }

    if (this.$route.query.ysc === '1') {
      if (this.isLoggedIn) {
        this.getYscUserInfo()
      } else {
        this.$store.dispatch('showLoginModal', { onSuccess: this.getYscUserInfo })
      }
    }
  },

  // need help
  beforeRouteUpdate: function (to, from, next) {
    const exploringCategories = to.name === 'projectsCategory'

    if (exploringCategories) {
      this.resetVars()
      this.resetAllCategories()
    } else {
      this._set(this.stateObjectKey, this.getState())
    }

    next()

    if (exploringCategories && this.$route.params.category) {
      this.showCategory(this.$route.params.category)
    } else {
      this.refresh()
    }
  },

  beforeRouteLeave: function (to, from, next) {
    this._callback('unlockScrolling')
    const isSameComponent = to.name === 'home' || to.name === 'projectsCategory'
    this.projects = []
    if (isSameComponent) {
      this.resetVars()
      this.resetAllCategories()
    } else {
      this._set(this.stateObjectKey, this.getState())
    }

    next()

    if (isSameComponent) {
      if (to.params.category) {
        this.showCategory(to.params.category)
      } else {
        this.refresh()
      }
    }
  },
  watch: {
    $route (to, from) {
      if (this.$isOhioScience) {
        this.$store.dispatch('getCategories', this.$route.path.substring(1)).then(() => {
          this.runWhenMounted()
        })
      }
    },
    '$store.getters.userCategories': function (value) {
      if (this.isLoggedIn) {
        this.userCategories = value.userCategories.slice().sort((a, b) => a.name.localeCompare(b.name))
      }
    },
    '$store.getters.userFilterTags.tags': function (value) {
      this.resetVars()
      this.resetRows()
      this.fetchRows()
    },
    isLoggedIn: function (userSignedIn) {
      this.resetVars()
      this.resetRows()
      this.fetchRows()
      this.$store.dispatch('getCategories', this.$route.path.substring(1))
      if (userSignedIn) {
        this.fetchCategories()
      }
    },
    '$i18n.locale': function () {
      // this tells the store what version of the categories to choose
      this.$store.dispatch('updateSelectedLanguage', this.$i18n.locale)
    },
    refreshComponentKey: function () {
      this.resetVars()
      this.resetRows()
      this.fetchRows()
    }
  },
  computed: {
    showPersonalize: function () {
      return !this.$isOhioScience && !this.$isSigmaXi
    },
    showPartner: function () {
      return !this.isStemExpo && !this.isBuckeye && !this.isOasam && !this.$isYSC
    },
    isExpo: function () {
      return this.$route.name === 'explore-page'
    },
    isStemExpo: function () {
      return this.$route.path.replace('/', '') === 'stem-expo'
    },
    isCareerHall: function () {
      return this.$route.name === 'career-hall' || this.$route.path.includes('career-hall')
    },
    isExplorePage: function () {
      return this.$route.name === 'explore-page' || this.$route.path.includes('explore-page')
    },
    isStemHall: function () {
      return this.$route.name === 'stem-experiential-hall' || this.$route.path.includes('stem-experiential-hall') || this.$route.path.includes('stem-hall')
    },
    isIsefHome: function () {
      return this.$route.name === 'home' && this.$isIsef
    },
    isHeise: function () {
      return this.appName === 'heise'
    },
    isCnmi: function () {
      return this.appName === 'cnmiiwsf'
    },
    isOasam: function () {
      return this.appName === 'oasam'
    },
    isOhiosci: function () {
      return this.appName === 'ohiosci'
    },
    isBuckeye: function () {
      if (this.appName === 'ohiosci') {
        return this.$route.path.substring(1) === 'bsef'
      } else {
        return this.appName === 'buckeye'
      }
    },
    isOasFairs: function () {
      return this.isBelieveInOhio || this.isBuckeye || this.isScienceDay || this.isStateScienceDay
    },
    isSigmaxi: function () {
      return this.appName === 'sigmaxi'
    },
    isBelieveInOhio: function () {
      return this.isHomePage && this.isOhiosci
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    userCategoriesSorted: function () {
      if (this.userCategories && this.userCategories.length > 0) {
        const parents = {}
        const categories = []
        this.userCategories.forEach((category) => {
          if (category.parentID !== 0 && !parents[category.parentID]) {
            const parent = this.$store.getters.categoryByID(category.parentID)
            if (parent) {
              categories.push(parent)
              parents[category.parentID] = true
            }
          }
          categories.push(category)
        })
        return categories
      }
      return []
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    hasError: function () {
      return this.error !== ''
    },
    isIE () {
      return breakpoints.isIE
    },
    currentTitle: function () {
      if (this.selectedCategory && this.currentCategory !== this.allCategories) {
        if (this.$route.params.category === this.selectedCategory.name) {
          return ''
        }
        switch (this.selectedCategory.name) {
          case 'AR/VR':
            return 'Augmented Reality / Virtual Reality'
          case 'PLM/ERP':
            return 'Product Lifecycle Management / Enterprise Resource Planning'
          case 'IoT':
            return 'Internet of Things'
          case 'BIM':
            return 'Building Information Modeling'
        }
        return this.selectedCategory.name
      } if (this.$isIsef) {
        switch (this.$route.name) {
          case 'career-hall':
            return 'Career Hall'
          case 'stem-experiential-hall':
            return 'STEM Experiential Hall'
          case 'home':
            return 'Finalist Exhibit Hall'
        }
      } if (this.$isYSC && this.$route.name === 'home') {
        return this.$t('banners.ysc.title-1') + this.currentYear + this.$t('banners.ysc.title-2')
      } if (this.$isHeise) {
        switch (this.$route.name) {
          case 'home':
            return 'Erkunden'
        }
      } else {
        return 'Home'
      }
    },
    hasCategoryFilter: function () {
      return this.currentCategory !== this.ALL_CATEGORIES
    },
    selectedCategory: function () {
      return this.$store.getters.categoryByID(this.selectedCategoryID)
    },
    selectedCategorySubCategories: function () {
      return this.$store.getters.subCategoriesForID(this.selectedCategoryID)
    },
    showSubCategoryRows: function () {
      if (this.selectedCategoryID === 0) {
        return false
      }

      return this.selectedCategory && this.selectedCategory.subCategories && this.selectedCategory.subCategories.length > 0
    },
    showSubAwardRows: function () {
      // return this.currentCategory === this.OUTSTANDING
      return false
    },
    defaultSort: function () {
      if (this.$route.fullPath === '/category/stem-games') {
        return 'most_views'
      } else {
        return this.$isEngCom ? 'newest' : 'recent_activity'
      }
    },
    sortOptions: function () {
      return this.$isEngCom ? this.newEngCategoryFilter : pbOptions
    },
    showSortContainer: function () {
      return this.hasError ? false : this.hasCategoryFilter && !this.showSubCategoryRows
    },
    newEngCategoryFilter: function () {
      if (this.currentCategory !== 'STEM Games') {
        return newengOptions.filter(sorts => sorts.value !== 'alphabetically')
      } else {
        return newengOptions
      }
    },
    isTouch: function () {
      return breakpoints.isTouch()
    },
    errorMessage: function () {
      if (this.$isYSC) {
        return this.yscErrorMessages(this.currentCategory)
      } else {
        return this.notFoundErrorMessage
      }
    },
    showSponsor: function () {
      return !this.hasCategoryFilter
    },
    isMakerFaire: function () {
      return this.currentCategory.includes('Maker Faires')
    },
    allCategoriesTitle: function () {
      return this.$isYSC ? i18n.t('explore.allChallenges') : this.ALL_CATEGORIES
    },
    hasCategories: function () {
      if (!this.isOasFairs || !this.isHomePage) {
        return this.$store.getters.categoriesLoaded
      } else if (this.isOasFairs || this.isHomePage) {
        return false
      }
    },
    showAd: function () {
      return this.hasCategoryFilter && !this.$isEngCom
    },
    isLoading: function () {
      if (this.isBeforeAjasReleaseDate) {
        return false
      } else {
        return true
      }
    },
    refreshComponentKey: function () {
      // This is used to force rerender the component
      // If this value changes Vue will know to rerender the whole component
      // We will need to build cases for each way we are using the same component
      let newKey = this.$route.name
      if (this.$route.params) {
        if (this.$route.params.explorepage) {
          newKey = newKey + '-' + this.$route.params.explorepage
        }
      }
      return newKey
    },
    exloreAllMessage: function () {
      return !this.$isGirlsAndSteam && !this.isMakerFaire && (!this.$isIsef || this.isIsefHome)
    },
    buttonText: function () {
      if (this.$store.getters.userFilterTags.tags && this.$store.getters.userFilterTags.tags.length > 0) {
        return 'Filter Active'
      }
      return this.$t('filterModal.filter')
    },
    isScienceDay: function () {
      return this.$route.path.substring(1) === 'scienceday'
    },
    isStateScienceDay: function () {
      return this.$route.path.substring(1) === 'state-science-day'
    },
    isHomePage: function () {
      return this.$route.path.substring(1) === 'home'
    }
  },
  methods: {
    getOverlayPosY: function (banner) {
      // Get Pos
      const posYStart = this.isMobile ? 300 : 500
      // Get overlay element
      const overlay = window.document.getElementById('overlayIsef')
      // Check for overlay
      if (overlay) {
        // Check for banner
        if (banner) {
          overlay.style.setProperty('top', posYStart)
          // Check for banner existing only in Fare Explorer
          if (this.isStemHall || this.isCareerHall || this.isIsefHome) {
            window.addEventListener('scroll', e => {
              const overlay = window.document.getElementById('overlayIsef')
              if (overlay) {
                if (window.scrollY <= posYStart) {
                  window.document.getElementById('overlayIsef').style.setProperty('top', (posYStart - window.scrollY) + 'px')
                } else {
                  window.document.getElementById('overlayIsef').style.setProperty('top', 0)
                }
              }
            })
          }
        } else {
          window.document.getElementById('overlayIsef').style.setProperty('top', 0)
        }
      }
    },
    initCallbacks: function () {
      this._register('unshiftChristmasLights', this.unshiftChristmasLights)
      this._register('lockScrolling', this.lockScrolling)
      this._register('unlockScrolling', this.unlockScrolling)
    },
    unshiftChristmasLights: function () {
      if (this.$refs.banner.$refs.christmasLights && this.$refs.banner) {
        this.$refs.banner.$refs.christmasLights.isShifted = false
      }
    },
    getYscUserInfo: function () {
      this.$store.dispatch('getYscUserInfo')
    },
    runWhenMounted: function () {
      this.resetAllCategories()
      if (this.isLoggedIn) {
        this.$store.dispatch('cacheLikedProjects', this.currentUser.userName)
        this.$store.dispatch('cacheLikedPosts', this.currentUser.userName)
        this.$store.dispatch('cacheLikedComments', this.currentUser.userName)
        this.$store.dispatch('cacheSubscribedProjects', this.currentUser.userName)
        this.fetchCategories()
      }

      if (this.$route.params.category) {
        this.showCategory(this.$route.params.category)
      } else {
        this.refresh()
      }

      if (this.$route.query.create) {
        this.showChooseTemplateModal = true
      }
    },
    boardLabel: function (plural) {
      if (this.$isEngCom) {
        return plural ? 'stories' : 'story'
      } else {
        return plural ? 'boards' : 'board'
      }
    },
    personalizeFeed: function (source) {
      this.$refs.categoryModal.showModal(source)
    },
    selectCountry: function (source) {
      this.$refs.countryModal.showModal(source)
    },
    filterOptions: function (source) {
      this.$refs.filterModal.showModal(source)
    },
    close: function () {
      this.showChooseTemplateModal = false
    },
    userCategoryInterestsChanged: function (changed) {
      if (changed) {
        this.rows = []
        this.exploreRows = []
        this.yscRows = []
        this.yscStemExpoRows = []
        this.isefCareerHallRows = []
        this.isefSTEMExperientialHallRows = []
        this.ajasRows = []
        this.premiumRows = []
        this.featuredRows = []
        this.fablabsRows = []
        this.bookmarkedRows = []
        this.wettbewerbeRows = []
        this.awardedProjects = []
        this.pbRows = []
        this.userCategoryRows = []
        this.restCategoryRows = []
        this.getPopulatedRows()
        this.$store.dispatch('getCategories', this.$route.path.substring(1))
        if (this.isLoggedIn) {
          this.fetchCategories()
        }
      }
    },
    applyUserTags: function (changed) {
      this.userTags = changed
    },
    fetchCategories: function () {
      if (!this.isOhiosci && !this.isSigmaxi) { // removing Interest Categories for Ohiosci Fairs
        this.$store.dispatch('getUserCategories', this.currentUser.userName).then((categories) => {
          this.userCategories = categories
        })
      }
    },
    exploreAll: function () {
      this.$router.push({ name: 'viewAll' })
    },
    rowHasProjects: function (title) {
      return (this.rowProjects[title] && this.rowProjects[title].length)
    },
    fetchRows: function () {
      if (this.hasRows) {
        return
      }
      this.getPopulatedRows()
    },
    getPopulatedRows: function () {
      if (this.$route.name && this.$route.name.includes('explore-page')) {
        home.getExplorePage(this.$route.params.explorepage).then((response) => {
          this.setPlaceholderProjects(response)
        })
      } else if (this.$isIsef) {
        if (this.$route.path.includes('career-hall')) {
          home.getCareerHall().then((response) => {
            this.setPlaceholderProjects(response)
          })
        }
        if (this.$route.path.includes('stem-experiential-hall')) {
          home.getSTEMExperientialHall().then((response) => {
            this.setPlaceholderProjects(response)
          })
        }
        if (this.$route.path.includes('home')) {
          home.getISEF().then((response) => {
            this.setPlaceholderProjects(response)
          })
        }
      } else if (this.$isYSC) {
        if (this.$route.path.includes('stem-expo')) {
          home.getYSCSTEMExpo(this.$i18n.locale).then((response) => {
            this.setPlaceholderProjects(response)
          })
        } else {
          home.getYSC().then((response) => {
            this.setPlaceholderProjects(response)
          })
        }
      } else if (this.$isAjas) {
        home.getAJAS().then((response) => {
          this.setPlaceholderProjects(response)
        })
      } else {
        let platform = 'projects'
        if (this.$isEngCom) {
          platform = 'stories'
        }
        const currentPage = this.$route.path.substring(1)
        home.get(platform, currentPage).then((response) => {
          this.setPlaceholderProjects(response)
        })
      }

      if (!this.subscribed) {
        socket.subscribeAll('project')
        this.subscribed = true
      }
    },
    setPlaceholderProjects: function (response) {
      this.hasRows = true

      if (response.data.result.explorePage) {
        this.exploreRows = response.data.result.explorePage.rows
        this.exploreRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.ysc) {
        this.yscRows = response.data.result.ysc.rows
        this.yscRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.yscSTEMExpo) {
        this.yscStemExpoRows = response.data.result.yscSTEMExpo.rows
        this.yscStemExpoRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.isefCareerHall) {
        this.isefCareerHallRows = response.data.result.isefCareerHall.rows
        this.isefCareerHallRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.isefSTEMExperientialHall) {
        this.isefSTEMExperientialHallRows = response.data.result.isefSTEMExperientialHall.rows
        this.isefSTEMExperientialHallRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.ajas) {
        this.ajasRows = response.data.result.ajas.rows
        this.ajasRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.isef) {
        this.isefRows = response.data.result.isef.rows
        this.isefRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.fablabs) {
        this.fablabsRows = response.data.result.fablabs.rows
        this.fablabsRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.bookmarked) {
        this.bookmarkedRows = response.data.result.bookmarked.rows
        this.bookmarkedRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.wettbewerbe) {
        this.wettbewerbeRows = response.data.result.wettbewerbe.rows
        this.wettbewerbeRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.awardedProjects) {
        this.awardedProjects = response.data.result.awardedProjects.rows
        this.awardedProjects.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.premium && response.data.result.premium.rows) {
        this.premiumRows = response.data.result.premium.rows
        this.premiumRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (response.data.result.featured) {
        this.featuredRows = response.data.result.featured.rows
        this.featuredRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (this.isLoggedIn) {
        if (response.data.result.pb) {
          this.pbRows = response.data.result.pb.rows
          if (this.pbRows) {
            this.pbRows.forEach((row) => {
              this.$set(this.rowProjects, row.title, placeHolderProjects)
            })
          }
        }
      }

      this.userCategoryRows = response.data.result.userCategory.rows
      this.restCategoryRows = response.data.result.restCategory.rows?.filter(function (row) {
        return row.title !== 'Eng-Tips'
      })

      if (this.userCategoryRows) {
        this.userCategoryRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }

      if (this.restCategoryRows) {
        this.restCategoryRows.forEach((row) => {
          this.$set(this.rowProjects, row.title, placeHolderProjects)
        })
      }
    },
    populateRow: function (offset, rowType, extraParams) {
      if (!rowType) {
        return
      }
      let row = null
      switch (rowType) {
        case 'exploreRows':
          row = this.exploreRows[offset]
          break
        case 'yscRows':
          row = this.yscRows[offset]
          break
        case 'ajasRows':
          row = this.ajasRows[offset]
          break
        case 'isefRows':
          row = this.isefRows[offset]
          break
        case 'premiumRows':
          row = this.premiumRows[offset]
          break
        case 'featuredRows':
          row = this.featuredRows[offset]
          break
        case 'bookmarkedRows':
          row = this.bookmarkedRows[offset]
          break
        case 'fablabsRows':
          row = this.fablabsRows[offset]
          break
        case 'wettbewerbeRows':
          row = this.wettbewerbeRows[offset]
          break
        case 'awardedProjects':
          row = this.awardedProjects[offset]
          break
        case 'pbRows':
          row = this.pbRows[offset]
          break
        case 'userCategoryRows':
          row = this.userCategoryRows[offset]
          break
        case 'restCategoryRows':
          row = this.restCategoryRows[offset]
          break
        case 'yscStemExpoRows':
          row = this.yscStemExpoRows[offset]
          break
        case 'isefCareerHallRows':
          row = this.isefCareerHallRows[offset]
          break
        case 'isefSTEMExperientialHallRows':
          row = this.isefSTEMExperientialHallRows[offset]
          break
      }
      if (rowType === 'featuredRows' && extraParams) {
        if (extraParams.slug === 'latestProjects') {
          row.request.name = 'latestProjects'
        } else if (extraParams.slug === 'bookmarkedProjects') {
          row.request.name = 'bookmarkedProjects'
        } else {
          row.request.name = 'featuredProjects'
        }
      }
      let params = row.request.params
      if (extraParams) {
        params = Object.assign({}, params, extraParams)
        if (extraParams.slug === 'bookmarkedProjects') {
          const userNameParam = { username: this.currentUser.userName, includeCreated: true }
          params = Object.assign({}, params, userNameParam)
        }
        if (this.$store.getters.userFilterTags.tags && this.$store.getters.userFilterTags.tags.length > 0) {
          params.filterTags = this.$store.getters.userFilterTags.tags[0]
        }
        if (this.isOasFairs) {
          params.currentPage = this.$route.path.substring(1)
          params.filter = this.$route.path.substring(1)
        }
      }
      switch (row.request.name) {
        case 'featuredProjects':
          this.fetchFeaturedProjects(row.title, params)
          break
        case 'premiumProjects':
          this.fetchPremiumProjects(row.title, params)
          break
        case 'fablabsProjects':
          this.fetchFablabsProjects(row.title, params)
          break
        case 'bookmarkedProjects':
          this.fetchBookmarkedProjects(row.title, params)
          break
        case 'wettbewerbProjects':
          this.fetchWettbewerbProjects(row.title, params)
          break
        case 'popularProjects':
          this.fetchPopularProjects(row.title, params)
          break
        case 'recommendedProjects':
          this.fetchRecommendedProjects(row.title, params)
          break
        case 'projectsByCategory':
          this.fetchProjectsByCategory(row.title, params)
          break
        case 'awardedProjects':
          this.fetchAwardedProjects(row.title, params)
          break
        case 'latestProjects':
          this.fetchProjectsWithParams(row.title, params)
          break
        case 'contributedTo':
          this.fetchContributedTo(row.title, params)
          break
        case 'recentProjects':
          this.fetchProjectsWithParams(row.title, params)
          break
        case 'getProjectsByTag':
          this.fetchProjectsByTag(row.title, params)
          break
        case 'getProjectsByTemplateID':
          this.fetchProjectsByTemplateID(row.title, params)
          break
        case 'getProjectsByTemplateIDs':
          this.fetchProjectsByTemplateIDs(row.title, params)
          break
        case 'getProjectsByAward':
          this.fetchProjectsByAwardID(row.title, params)
          break
        case 'getYSC2022AwardProjects':
          this.fetchYsc2022Awards(row.title, params)
          break
        default:
          this.fetch(row.title, row.request.name, params)
      }
    },
    fetchProjectsByCategory: function (category, params) {
      if (this.isRowPopulated(category) && !params.refresh) {
        return
      }

      //  YSC Landing page should show only 2022 Awarded Projects
      if (this.$isYSC && this.$route.name === 'home') {
        params.filter = 'CWSF2022AwardOnly'
        params.sort = 'award'
      }

      if (this.$store.getters.userFilterTags.tags && this.$store.getters.userFilterTags.tags.length > 0) {
        params.filterTags = this.$store.getters.userFilterTags.tags
      }
      this.$store.dispatch('getProjectsByCategory', params).then((response) => {
        if (response.total > 0 || this.$isOhioScience) {
          this.$set(this.rowProjects, category, response.projects)
        }
      })
    },
    fetchProjectsByTag: function (category, params) {
      params.tag = category.replace(/\s/g, '')
      this.$store.dispatch('getProjectsByTag', params).then((response) => {
        this.$set(this.rowProjects, category, response.projects)
      }).catch(() => {
        this.error = 'Tag not found'
      })
    },
    fetchProjectsByTemplateID: function (category, params) {
      this.$store.dispatch('getProjectsByTemplateID', params).then((response) => {
        this.$set(this.rowProjects, category, response.projects)
      }).catch(() => {
        this.error = 'TemplateID not found'
      })
    },
    fetchProjectsByTemplateIDs: function (category, params) {
      this.$store.dispatch('getProjectsByTemplateIDs', params).then((response) => {
        this.$set(this.rowProjects, category, response.projects)
      }).catch(() => {
        this.error = 'TemplateID not found'
      })
    },
    fetchProjectsByAwardID: function (category, params) {
      this.$store.dispatch('getProjectsByAward', params).then((response) => {
        this.$set(this.rowProjects, category, response.projects)
      }).catch(() => {
        this.error = 'AwardID not found'
      })
    },
    fetchYsc2022Awards: function (category, params) {
      this.$store.dispatch('getYsc2022AwardProjects', params).then((response) => {
        this.$set(this.rowProjects, category, response.projects)
      }).catch(() => {
        this.error = 'AwardID not found'
      })
    },
    fetchFeaturedProjects: function (title, params) {
      this.fetch(title, 'getFeaturedProjects', params)
    },
    fetchBookmarkedProjects: function (title, params) {
      this.fetch(title, 'getBookmarkedProjects', params)
    },
    fetchPremiumProjects: function (title, params) {
      this.fetch(title, 'getPremiumProjects', params)
    },
    fetchAwardedProjects: function (title, params) {
      this.fetch(title, 'getAwardedProjects', params)
    },
    fetchFablabsProjects: function (title, params) {
      this.fetch(title, 'getFablabsProjects', params)
    },
    fetchWettbewerbProjects: function (title, params) {
      this.fetch(title, 'getWettbewerbeProjects', params)
    },
    fetchPopularProjects: function (title, params) {
      this.fetch(title, 'getPopularProjects', params, true)
    },
    fetchRecommendedProjects: function (title, params) {
      this.fetch(title, 'getRecommendedProjects', params, true)
    },
    fetchContributedTo: function (title, params) {
      params.username = this.$store.getters.currentUser.userName
      params.offset = 0
      params.includeCreated = true
      this.fetch(title, 'getProjectsContributedTo', params, true)
    },
    fetchProjectsWithParams: function (title, params) {
      let isFeatured = false
      if (title.startsWith(this.FEATURED_KEY)) {
        isFeatured = true
      }
      if ((isFeatured && params.slug === 'latestProjects') || this.sortBy === 'newest') {
        params.sort = this.$isEngCom ? 'published' : 'newest'
      }
      this.fetch(title, 'getProjects', params, !isFeatured)
    },
    fetch: function (title, dispatch, params, shouldFetch) {
      if (this.isRowPopulated(title) && shouldFetch) {
        return
      }
      this.$store.dispatch(dispatch, params).then((response) => {
        this.$set(this.rowProjects, title, response.projects)
      }).catch(() => {
        this.error = 'No projects found'
      })
    },
    filterSearch: function (searchValue) {
      this.resetVars()

      this.dispatchMethod = ''
      this.dispatchMethod = searchValue !== this.ALL_CATEGORIES ? 'getProjectsByCategory' : ''
      this.currentCategory = searchValue

      if (this.dispatchMethod === 'getProjectsByCategory') {
        const category = this.$store.getters.categoryByName(this.currentCategory)
        if (category) {
          this.selectedCategoryID = category.id
        }
      } else {
        this.selectedCategoryID = 0
      }

      this.refresh()
    },
    resetVars: function () {
      this.error = ''
      this.projects = []
      this.offset = 0
      this.subscribed = false
      this.sortBy = !this.sortBy ? this.defaultSort : this.sortBy
      this.sorting = false
      this.filterSortBy = null
      this.featuredProjects = []
    },
    resetAllCategories: function () {
      this.dispatchMethod = ''
      this.currentCategory = this.ALL_CATEGORIES
      this.currentBoard = this.ALL_BOARDS
      this.sortBy = this.defaultSort
      this.selectedCategoryID = 0
      this.metaTitle = ''
    },
    resetRows: function () {
      this.hasRows = false
      this.exploreRows = []
      this.yscRows = []
      this.yscStemExpoRows = []
      this.isefCareerHallRows = []
      this.isefSTEMExperientialHallRows = []
      this.ajasRows = []
      this.isefRows = []
      this.premiumRows = []
      this.featuredRows = []
      this.pbRows = []
      this.userCategoryRows = []
      this.restCategoryRows = []
    },
    refresh: function () {
      const state = this._pop(this.stateObjectKey)
      if (!state || !this.restoreState(state)) {
        this._callback('scrollToPoint')
        this.projects = []
        this.fetchProjects()
        if (!this.subscribed) {
          socket.subscribeAll('project')
          this.subscribed = true
        }
      }
    },
    fetchProjects: function () {
      if (this.showSubAwardRows) {
        return this.buildSubAwardRows()
      }

      if (this.dispatchMethod === '') {
        this.fetchRows()
        this.dispatchMethod = 'getProjects'
        return
      }

      if (this.showSubCategoryRows && this.dispatchMethod === 'getProjectsByCategory') {
        return this.buildSubCategoryRows()
      }

      const fetchCount = ++this.fetchCount
      const params = this.buildFetchParams()
      this.error = ''
      this.$store.dispatch(this.dispatchMethod, params).then((response) => {
        if (fetchCount !== this.fetchCount) {
          // another fetch has superceded this one
          return
        }

        this.projects.push.apply(this.projects, response.projects)
        if (this.projects.length === 0) {
          this.error = this.errorMessage
        }
        this.offset += this.limit
        this.sorting = false

        if (response.category) {
          this.currentCategory = response.category.name
          this.selectedCategoryID = response.category.id
        }
      }).catch(() => {
        this.error = this.errorMessage
      })
    },
    buildFetchParams: function () {
      const params = {}

      params.sort = this.sortBy || this.defaultSort
      params.limit = this.limit
      params.offset = this.offset
      params.pinned = true

      if (this.filterSortBy !== null) {
        params.sort = this.filterSortBy
      }

      if (this.dispatchMethod === 'getPopularProjects') {
        params.query = 'month'
      }
      if (this.dispatchMethod === 'getProjectsByCategory') {
        params.slug = this.getSlugForCategory()
      }
      if (this.isOasFairs) {
        params.currentpage = this.$route.path.substring(1)
      }

      return params
    },
    showCategory: function (slug) {
      const category = this.$store.getters.categoryBySlug(slug)
      if (!category) {
        // check to see if the categories have been loaded at all
        const categoryLen = this.$store.getters.projectCategories()
        if (categoryLen?.length > 0) {
          // this category doesnt exist so go to the home view
          this.resetVars()
          this.resetAllCategories()
          this.refresh()
        }
        return
      }
      this.resetVars()
      this._delete(this.stateObjectKey)
      this.dispatchMethod = 'getProjectsByCategory'
      this.sortBy = this.defaultSort
      this.currentCategory = category.name
      this.selectedCategoryID = category.id
      this.refresh()
    },
    updateSort: function () {
      this.sorting = true
      this.projects = []
      this.offset = 0
      this.fetchProjects()
      if (this.showSubCategoryRows) {
        for (let i = 0; i < this.selectedCategorySubCategories.length; i++) {
          this.populateSubCategoryRow(i)
        }
      } else if (this.showSubAwardRows) {
        for (let i = 0; i < this.subAwardCategories.length; i++) {
          this.populateSubAwardRow(i, this.subAwardCategories[i].slug)
        }
      }
    },
    isRowPopulated: function (title) {
      // is row is empty?
      if (!this.rowProjects[title] || this.rowProjects[title].length === 0) {
        return false
      }

      // row has placeholders?
      if (this.rowProjects[title].length === placeHolderProjects.length) {
        return this.rowProjects[title][0].id !== placeHolderProjects[0].id
      }

      return true
    },
    getState: function () {
      const rowState = {}
      if (this.$refs.exploreRows && this.$refs.exploreRows.length > 0) {
        this.$refs.exploreRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.yscRows && this.$refs.yscRows.length > 0) {
        this.$refs.yscRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.yscStemExpoRows && this.$refs.yscStemExpoRows.length > 0) {
        this.$refs.yscStemExpoRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.isefCareerHallRows && this.$refs.isefCareerHallRows.length > 0) {
        this.$refs.isefCareerHallRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.isefSTEMExperientialHallRows && this.$refs.isefSTEMExperientialHallRows.length > 0) {
        this.$refs.isefSTEMExperientialHallRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.ajasRows && this.$refs.ajasRows.length > 0) {
        this.$refs.ajasRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.isefRows && this.$refs.isefRows.length > 0) {
        this.$refs.isefRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.featuredRows && this.$refs.featuredRows.length > 0) {
        this.$refs.featuredRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.bookmarkedRows && this.$refs.bookmarkedRows.length > 0) {
        this.$refs.bookmarkedRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.pbRows && this.$refs.pbRows.length > 0) {
        this.$refs.pbRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.userCategoryRows && this.$refs.userCategoryRows.length > 0) {
        this.$refs.userCategoryRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      if (this.$refs.restCategoryRows && this.$refs.restCategoryRows.length > 0) {
        this.$refs.restCategoryRows.forEach((row) => {
          rowState[row.title] = row.getState()
        })
      }

      const subCategoryRowState = {}
      if (this.$refs.subCategoryRows && this.$refs.subCategoryRows.length > 0) {
        this.$refs.subCategoryRows.forEach((row) => {
          subCategoryRowState[row.categorySlug] = row.getState()
        })
      }

      return {
        projectIDs: this.projects.map((p) => { return p.id }),
        hasRows: this.hasRows,
        exploreRows: this.exploreRows,
        yscRows: this.yscRows,
        yscStemExpoRows: this.yscStemExpoRows,
        isefCareerHallRows: this.isefCareerHallRows,
        isefSTEMExperientialHallRows: this.isefSTEMExperientialHallRows,
        ajasRows: this.ajasRows,
        isefRows: this.isefRows,
        fablabsRows: this.fablabsRows,
        bookmarkedRows: this.bookmarkedRows,
        wettbewerbeRows: this.wettbewerbeRows,
        awardedProjects: this.awardedProjects,
        premiumRows: this.premiumRows,
        featuredRows: this.featuredRows,
        pbRows: this.pbRows,
        userCategoryRows: this.userCategoryRows,
        restCategoryRows: this.restCategoryRows,
        featuredProjectIDs: this.featuredProjectIDs,
        offset: this.offset,
        dispatchMethod: this.dispatchMethod,
        scroll: document.body.scrollTop || document.documentElement.scrollTop,
        refreshKey: this.$route.query.r,
        sortBy: this.sortBy,
        filterSortBy: this.filterSortBy,
        error: this.error,
        currentCategory: this.currentCategory,
        currentBoard: this.currentBoard,
        selectedCategoryID: this.selectedCategoryID,
        rowState,
        subCategoryRowState
      }
    },
    restoreState: function (state) {
      this.$store.getters.newProjectIds.forEach((id) => {
        state.projectIDs.unshift(id)
      })

      this.$store.dispatch('clearNewProjects')

      const clickedWordmark = this.$route.query.r !== state.refreshKey
      if (clickedWordmark) {
        this.resetAllCategories()
        return false
      }

      this.dispatchMethod = state.dispatchMethod
      this.sortBy = state.sortBy
      this.filterSortBy = state.filterSortBy
      this.error = state.error
      this.currentCategory = state.currentCategory
      this.currentBoard = state.currentBoard
      this.selectedCategoryID = state.selectedCategoryID

      const projects = this.$store.getters.cachedProjects(state.projectIDs)
      if (!projects || projects.length === 0) {
        // need to refetch projects, so start at the first page
        this.resetAllCategories()
        return false
      }
      this.projects = projects
      this.rowProjects = {}
      this.hasRows = state.hasRows
      this.exploreRows = state.exploreRows
      this.yscRows = state.yscRows
      this.yscStemExpoRows = state.yscStemExpoRows
      this.isefCareerHallRows = state.isefCareerHallRows
      this.isefSTEMExperientialHallRows = state.isefSTEMExperientialHallRows
      this.ajasRows = state.ajasRows
      this.isefRows = state.isefRows
      this.fablabsRows = state.fablabsRows
      this.bookmarkedRows = state.bookmarkedRows
      this.wettbewerbeRows = state.wettbewerbeRows
      this.awardedProjects = state.awardedProjects
      this.premiumRows = state.premiumRows
      this.featuredRows = state.featuredRows
      this.pbRows = state.pbRows
      this.userCategoryRows = state.userCategoryRows
      this.restCategoryRows = state.restCategoryRows
      this.rowState = state.rowState

      this.restoreRowState(state, this.yscRows)
      this.restoreRowState(state, this.exploreRows)
      this.restoreRowState(state, this.yscStemExpoRows)
      this.restoreRowState(state, this.isefCareerHallRows)
      this.restoreRowState(state, this.isefSTEMExperientialHallRows)
      this.restoreRowState(state, this.ajasRows)
      this.restoreRowState(state, this.isefRows)
      this.restoreRowState(state, this.fablabsRows)
      this.restoreRowState(state, this.bookmarkedRows)
      this.restoreRowState(state, this.wettbewerbeRows)
      this.restoreRowState(state, this.awardedProjects)
      this.restoreRowState(state, this.premiumRows)
      this.restoreRowState(state, this.featuredRows)
      this.restoreRowState(state, this.pbRows)
      this.restoreRowState(state, this.userCategoryRows)
      this.restoreRowState(state, this.restCategoryRows)

      this.subCategoryProjects = {}
      this.subCategoryRowState = state.subCategoryRowState
      this.selectedCategorySubCategories.forEach((sub) => {
        this.$set(this.subCategoryProjects, sub.slug, placeHolderProjects)
        if (state.subCategoryRowState[sub.slug]) {
          const projects = this.$store.getters.cachedProjects(state.subCategoryRowState[sub.slug].projectIDs)
          if (projects) {
            this.$set(this.subCategoryProjects, sub.slug, projects)
          }
        }
      })
      this.offset = state.offset
      if (state.featuredProjectIDs && state.featuredProjectIDs.length > 0) {
        const featuredProjects = this.$store.getters.cachedProjects(state.featuredProjectIDs)
        if (featuredProjects) {
          this.featuredProjects = featuredProjects
        }
      }
      if (state.scroll) {
        this.$nextTick(() => {
          // 0 second timeout fixes issue with safari and back button
          setTimeout(() => {
            window.scrollTo({
              top: state.scroll,
              behavior: 'smooth'
            })
          }, 0)
        })
      }
      return true
    },
    restoreRowState: function (state, rowType) {
      if (!rowType) {
        return
      }

      rowType.forEach((row) => {
        this.$set(this.rowProjects, row.title, placeHolderProjects)
        if (state.rowState[row.title]) {
        // restore projects for this row
          if (state.rowState[row.title].projectIDs) {
            const projects = this.$store.getters.cachedProjects(state.rowState[row.title].projectIDs)
            if (projects) {
              this.$set(this.rowProjects, row.title, projects)
            }
          }
        }
      })
    },
    getSlugForCategory: function () {
      if (this.selectedCategoryID > 0) {
        const category = this.$store.getters.categoryByID(this.selectedCategoryID)
        if (category) {
          return category.slug
        }
      }
    },
    buildSubCategoryRows: function () {
      this.subCategoryProjects = {}
      this.selectedCategorySubCategories.forEach((sub) => {
        this.$set(this.subCategoryProjects, sub.slug, placeHolderProjects)
      })
    },
    populateSubCategoryRow: function (slugOrOffset) {
      let sub = null
      if (typeof slugOrOffset === 'string') {
        sub = this.$store.getters.categoryBySlug(slugOrOffset)
      } else {
        sub = this.selectedCategorySubCategories[slugOrOffset]
        if (!sub) {
          return
        }
      }

      const params = this.buildFetchParams()
      params.slug = sub.slug
      const parent = this.$store.getters.categoryByID(sub.parentID)
      this.$store.dispatch('getProjectsByCategory', params).then((response) => {
        if (this.selectedCategoryID === sub.parentID) {
          this.$set(this.subCategoryProjects, sub.slug, response.projects)
        } else if (this.selectedCategoryID > 0) {
          this.$set(this.subCategoryProjects, parent.slug, response.projects)
        } else {
          this.$set(this.rowProjects, parent.name, response.projects)
        }
      })
    },
    startNow: function () {
      this.showChooseTemplateModal = true
    },
    buildSubAwardRows: function () {
      this.subAwardProjects = {}
      this.subAwardCategories.forEach((sub) => {
        this.$set(this.subAwardProjects, sub.slug, placeHolderProjects)
      })
    },
    subAwardHasProjects: function (slug) {
      return (this.subAwardProjects[slug] && this.subAwardProjects[slug].length)
    },
    populateSubAwardRow: function (offset, rowType) {
      const sub = this.subAwardCategories[offset]
      if (!sub) {
        return
      }

      const params = this.buildFetchParams()
      let awardDispatchMethod = ''
      switch (rowType) {
        case 'regional-ribbon':
          params.awardID = 1
          awardDispatchMethod = 'getProjectsByAward'
          break
        case 'challenge-ribbon':
          awardDispatchMethod = 'getYscChallengeAwardProjects'
          break
        case 'ysc-ribbon':
          params.awardID = 2
          awardDispatchMethod = 'getProjectsByAward'
          break
      }

      this.$store.dispatch(awardDispatchMethod, params).then((response) => {
        this.$set(this.subAwardProjects, sub.slug, response.projects)
      })
    },
    clickCategory: function (category) {
      if (category.subCategories && category.subCategories.length > 0) {
        this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .language-white-background {
    background: white;
  }

  .overlay {
    background-image: url('https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/IsefResources%2Ffinalist_background.png?alt=media&token=2afe3e5b-1362-4758-98f7-72b97bd269f8');
    background-size: cover;
    height: 100vh; width: 100%;
    position: fixed; z-index: -13;
    background-position: top;

    &_fair {
      background-color: #a7a9a2;
      background-image: none !important;
     }

    @include mobile {
      background-size: cover;
    }
  }

  .home-section {
    z-index: -12;
    background-color: var(--background-fifth);
    padding-top: 1rem;
    min-height: calc(100vh - #{$navbar-height});
    &_stem-expo {
      background-color: #ececec !important;
    }
    &_isef-home {
      background: linear-gradient(180deg, #00031C 0%, #06003F 100%), #00031C;
      padding-top: 0 !important;
    }
  }

  .ad-container {
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .sort-container {
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 2.5rem 1.37rem 0 2.3rem;
  }

  .sort-container.title-and-sort {
    justify-content: space-between;
  }

  .select {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .option {
    font-size: 0.9rem;
    min-height: 0;
  }

  .projects-container {
    padding-left: 1.3rem;
    padding-bottom: 7rem;
    &.filtered-projects-container {
      padding-left: 0;
    }
    &.stories {
      max-width: 100%;
      width: 100%;
      padding-left: 1.3rem;
    }
  }

  .current-title {
    padding-right: 1.5rem;
    text-align: center;
    text-transform: capitalize;
  }

  .ieFix {
    min-width: 16rem;
    min-height: 16.5rem;
    margin: 1rem 1.7rem;
  }

  .all-categories {
    margin-bottom: 1rem;
  }

  .interests {
    position: static;
    margin: 2.2rem 0 3rem 1.5rem;
    align-items: center;
    justify-content: flex-start;
    position: static;
    .interests-title {
      position: static;
      font-size: 1.7em;
      font-weight: 600;
      margin-right: 1.5rem;
      color: var(--background-third);
      &_isef {
        color: white !important;
      }
      &_isefText {
        margin-top: 25px;
      }
      @include mobile {
        font-size: 1em;
      }
      @media (min-width: 401px) {
        padding: 10px 15px;
      }
      @media (max-width: 400px) {
        padding: 5px 7px;
      }
    }
    img {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      margin-left: 0.8rem;
    }
  }
  .interests-sub {
    flex-direction: row;
    display: flex;
  }

  // PERSONALIZE BUTTON STYLES
  .personalize-button-margin {
    margin-left: 2rem;
    @include mobile {
      margin-left: 0;
    }
  }
  .remove-margin {
    margin-left: 0;
  }
  .personalize-button-container {
    display: flex;
    justify-content: center;
    margin: 0;

    &_star {
      background-color: orange;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      padding: .2rem;
    }

    &_isef {
      margin-top: 2.5rem;
      margin-left: 0 !important;
      position: absolute;
      top: 15.5rem;
      left: 50%;
      transform: translate(-50%, -50%);
      @include mobile {
        margin-top: 0;
      }
    }
    &_logged-out {
      margin-top: 1.5rem;
      width: 100%;
      justify-content: space-around;
    }
  }

  .category-image {
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }

  .not-found {
    padding: 4rem 0;
    text-align: center;
  }

  .no-boards-message {
    text-align: center;
    padding-top: 2.3rem;
    &_isef {
      color: white !important;
      @include mobile {
        margin-top: 1rem;
      }
    }
    a {
      font-weight: 700;
    }
  }

  @include tablet-only {
    .projects-container {
      &.stories {
        padding-left: 0.69rem
      }
    }
    .sort-container {
      padding: 2.5rem 1.37rem 0 1.7rem;
    }
  }

  @include mobile {
    .sort-container {
      padding: 1rem 0.75rem 0;
    }
    .select {
      font-size: 0.8rem;
    }
    .option {
      font-size: 0.6rem;
    }
    .projects-container {
      padding-left: 0.75rem;
      &.filtered-projects-container {
        padding-left: 0.75rem;
      }
      &.stories {
        padding-left: 0.69rem
      }
    }
    .current-title {
      width: 100%;
      text-align: left;
      line-height: 1.25;
    }
    .all-categories-title {
      margin-top: 0.5rem;

      &_isef {
        color: white !important;
      }
    }
    .interests {
      margin: 0.7rem;
      flex-direction: flex;
      .interests-title {
        margin-right: 0.5rem;
      }
    }
    .no-boards-message {
      padding-right: 0.69rem
    }
  }

  @include mini-mobile {
    .sort-container {
      padding: 1rem 0.75rem 0;
    }
  }
  .user-tags {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .tag {
    margin: 0.15rem 0.3rem 0.15rem 0;
    font-size: 0.8rem;
    margin-bottom: 0.3rem;
    color: $grey-dark;
    background-color: $white;
    border-radius: 2px;
    border: 1px solid $grey-light;
  }
  .adjust-margin {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .adjust-margin-personalize {
    margin-top: -0.6rem;
  }
</style>
